import { render, staticRenderFns } from "./watertransfer.vue?vue&type=template&id=0f5ad38a&scoped=true&"
import script from "./watertransfer.vue?vue&type=script&lang=js&"
export * from "./watertransfer.vue?vue&type=script&lang=js&"
import style0 from "./watertransfer.vue?vue&type=style&index=0&id=0f5ad38a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5ad38a",
  null
  
)

export default component.exports